// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDatasupermarketIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDatasupermarketIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDatasupermarketIconOutlined = function DrrpDatasupermarketIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDatasupermarketIconOutlinedSvg
  }));
};

DrrpDatasupermarketIconOutlined.displayName = 'DrrpDatasupermarketIconOutlined';
export default React.forwardRef(DrrpDatasupermarketIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDatasupermarketIconOutlined.js
// module id = 2549
// module chunks = 0